import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudDrizzle,
  faCloudRain,
  faClouds,
  faFog,
  faSmoke,
  faSnowflake,
  faSun,
  faSunDust,
  faSunHaze,
  faThunderstorm,
  faTornado,
  faWindWarning,
} from "@fortawesome/pro-duotone-svg-icons";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import { TWeather } from "redux/reducers/models/facility";
import { capitalizeWords } from "helpers/Helpers";
import { useTranslation } from "react-i18next";
import "./weather.scss";

function getWeatherCondition(weatherMain: string) {
  return CONDITIONS[weatherMain] ?? CONDITIONS.Clouds;
}

function getWeatherDescription(
  weatherMain: string,
  weatherDescription: string,
  translate: (key: string, options?: { defaultValue: string }) => string,
) {
  const fallback = capitalizeWords(weatherDescription || weatherMain);
  return translate(`weather.${weatherMain}`, { defaultValue: fallback });
}

export default function Weather(props: { weather: TWeather }) {
  const { weather } = props;
  const { t } = useTranslation();
  const weatherMain = weather.weather.main;
  const weatherCondition = weatherMain ? getWeatherCondition(weatherMain) : null;

  return (
    <div className="flex flex-row items-center justify-center">
      <p className="ml-1 weather-size">
        {weatherMain && weatherCondition ? (
          <>
            <FontAwesomeIcon icon={weatherCondition.icon} className={weatherCondition.theme} />

            <span className="weather-text ml-2">{`${String(weather.temperature.temperature)}\u00B0`} </span>
            <span className="weather-text weather-text-description">
              {getWeatherDescription(weatherMain, weather.weather.description, t)}
            </span>
          </>
        ) : (
          <>
            <FontAwesomeIcon icon={faCircleExclamation} className={"theme-clouds"} />
            <span className="weather-text ml-2">{t("Weather Unavailable")}</span>
          </>
        )}
      </p>
    </div>
  );
}

const CONDITIONS: Record<string, { icon: IconProp; theme: string }> = {
  Thunderstorm: { icon: faThunderstorm, theme: "theme-thunderstorm" },
  Drizzle: { icon: faCloudDrizzle, theme: "theme-drizzle" },
  Rain: { icon: faCloudRain, theme: "theme-rain" },
  Snow: { icon: faSnowflake, theme: "theme-snow" },
  Mist: { icon: faFog, theme: "theme-mist" },
  Smoke: { icon: faSmoke, theme: "theme-smoke" },
  Haze: { icon: faSunHaze, theme: "theme-haze" },
  Dust: { icon: faSunDust, theme: "theme-dust" },
  Fog: { icon: faFog, theme: "theme-fog" },
  Sand: { icon: faSunDust, theme: "theme-sand" },
  Ash: { icon: faSunDust, theme: "theme-ash" },
  Squall: { icon: faWindWarning, theme: "theme-squall" },
  Tornado: { icon: faTornado, theme: "theme-tornado" },
  Clear: { icon: faSun, theme: "theme-clear" },
  Clouds: { icon: faClouds, theme: "theme-clouds" },
};
